import script from "./Step.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step.vue?vue&type=script&setup=true&lang=ts"

import "./Step.vue?vue&type=style&index=0&id=258e72d2&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258e72d2"]])

export default __exports__